import { appFlawCatalog } from './appFlawCatalog.js';
import { buildAppFlawEvidenceSchema } from './appFlawCatalog/buildAppFlawEvidenceSchema.js';

const evidenceSchemas = Object.fromEntries(Object.entries(appFlawCatalog).map(([slug, flaw]) => [slug, buildAppFlawEvidenceSchema(flaw)]));

// Shape validation only. The intake gate must resolve evidence from trusted observation IDs.
export const validateAppFlawEvidence = ({ flawSlug, evidence } = {}) => {
  if (!Object.hasOwn(evidenceSchemas, flawSlug)) {
    return { success: false, code: 'APP_FLAW_UNKNOWN', data: { issues: [] } };
  }
  const result = evidenceSchemas[flawSlug].safeParse(evidence);
  if (!result.success) {
    return { success: false, code: 'APP_FLAW_EVIDENCE_INVALID', data: { issues: result.error.issues } };
  }
  return { success: true, data: { evidence: result.data } };
};
